import React, { Fragment, useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LogoutUserAction } from "../../redux/actions/userActions";

import Logo from "../images/logo.png";
import LogoBlack from "../images/logo-black.png";
import Favicon from "../images/logo-sm.png";
import { socket } from "../../utils/socket.js"
import api from "../../api";

import SideBarLinks from "./sideBarLinks";
import TopBar from "./TopBar";



const Home = ({setShowSupport}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedout, user, isAuthenticated } = useSelector(
    (state) => state.verifyEmailStore
  );

  const [expandHeader, setExpandHeader] = useState(window.innerWidth > 1000 ? true : false);
  const [hoverExpand, setHoverExpand] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1000);

  const [showAnnouncement, setShowAnnouncement] = useState(false);
  const [announcementData, setAnnouncementData] = useState(null);


  const logoutUser = () => {
    Object.keys(sessionStorage).forEach(key => {
      if (key.startsWith('announcement_')) {
        sessionStorage.removeItem(key);
      }
    });
    dispatch(LogoutUserAction());
  };

  useEffect(() => {
    if (isLoggedout) {
      localStorage.setItem("email", "");
      navigate("/login");
    }

    if(user?.status === "PENDING_APPROVAL"){
      navigate("/pending-approval")
    }


  }, [isLoggedout, navigate, isAuthenticated, user]);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const { data } = await api.get(`/api/v1/active-announcement`);
        if (data.success && data.announcement) {
          setAnnouncementData(data.announcement);
          const isSeen = sessionStorage.getItem(`announcement_${data.announcement.id}`);
          if (!isSeen) {
            setShowAnnouncement(true);
            sessionStorage.setItem(`announcement_${data.announcement.id}`, "true");
          }
        }
      } catch (error) {
        console.error("Failed to fetch announcement", error);
      }
    };
    fetchAnnouncement();
  }, []);

  // Update device width responsiveness
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 1000);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Only apply hover expand on desktop
  const handleMouseEnter = () => {
    if (!expandHeader && isDesktop) setHoverExpand(true);
  };

  const handleMouseLeave = () => {
    if (!expandHeader && isDesktop) setHoverExpand(false);
  };

  const isExpanded = expandHeader;




  const handleClick = () => {
    if (!isDesktop) {


      setExpandHeader(false);
      setHoverExpand(false);
    }
  };



  useEffect(() => {
    if (!isAuthenticated || !user) return;

    if (!socket.connected) {
      // Use `auth` instead of `opts.query` (reliable in socket.io v4)
      socket.auth = { userId: user.id };
      socket.connect();
    }

    socket.on("connect", () => {
      console.log("Socket connected:", socket.id);
    });

    socket.on("disconnect", (reason) => {
      console.log("Socket disconnected:", reason);
    });

    console.log(process.env.REACT_APP_BACKEND_URL)


    return () => {
      socket.off("connect");
      socket.off("disconnect");
    };
  }, [isAuthenticated, user]);
  return (
    <Fragment>
      {user?.role === 'Unauthorized' ?
        <section className="w-[100%] h-[100vh] flex-center" >
          <div className="p-[3vmax] flex-center flex-col w-[90%] lg:w-[60%]  bg-white shadow-1">
            <h2 className="text-[2.5vmax]  font-bold font-2" >🚫 Unauthorized Access</h2>
            <br />
            <p className="text-center" >
              This platform is restricted to admin use only. Unauthorized users are not permitted. If you are a Product Manager or Inventory Manager, please contact the admin to request access.
            </p>
            <br />
            <button className="bg-[image:var(--gradient)] text-white font-bold py-[0.8vmax] px-[2vmax] rounded-[2vmax] mt-[1vmax]"
              onClick={logoutUser}
            >Logout</button>
          </div>
        </section>
        :
        <section className="flex justify-between">
          {/* Backdrop (mobile only) */}
          {expandHeader && !isDesktop && (
            <div 
              className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[999999] lg:hidden"
              onClick={() => setExpandHeader(false)}
            />
          )}

          {/* Sidebar */}
          <div
            className={`${isExpanded ? "w-[280px] lg:w-[18%]" : "w-[0] lg:w-[5%]"
              } relative transition-all duration-300 bg-white dark:bg-slate-950 border-r border-slate-200 dark:border-slate-800 min-h-[100vh] `}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className={`${isExpanded || hoverExpand ? "w-[280px] lg:w-[18%]" : "w-[0] lg:w-[5%]"
                } fixed h-[100vh] top-0 left-0 transition-all duration-300 z-[1000000] `}
            >
              {/* Close button (mobile only) */}
              {expandHeader && (
                <button
                  onClick={() => setExpandHeader((prev) => !prev)}
                  className="lg:hidden absolute top-[1.5vmax] right-[1vmax] z-[200] text-[2.5vmax] text-slate-500 dark:text-slate-300 hover:text-slate-800 dark:hover:text-white"
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              )}

              <div className={`w-full h-full bg-white dark:bg-slate-950 shadow-1 flex flex-col items-center relative max-h-[100vh] overflow-auto my-scroll pb-[30vmax] lg:pb-0`}

              >
                {/* Logo */}
                <div
                  className={`lg:sticky top-0 left-0  z-10 flex-center  bg-white dark:bg-slate-950 ${isExpanded || hoverExpand ? "w-full " : " overflow-hidden"
                    }`}
                >
                  <Link to={"/"} onClick={() => handleClick()} className="flex items-center justify-center py-[1vmax]" >
                    {(isExpanded || hoverExpand) ? (
                      <>
                        <img
                          src={LogoBlack}
                          alt="Zonify Pro"
                          className="w-[20vmax] lg:w-[10vmax] dark:hidden"
                        />
                        <img
                          src={Logo}
                          alt="Zonify Pro"
                          className="hidden w-[20vmax] lg:w-[10vmax] dark:block"
                        />
                      </>
                    ) : (
                      <img
                        src={Favicon}
                        alt="Zonify Pro"
                        className="w-[2vmax]"
                      />
                    )}
                  </Link>
                </div>

                {/* Links */}
                <SideBarLinks isExpanded={isExpanded} hoverExpand={hoverExpand} handleClick={handleClick} logoutUser={logoutUser} role={user?.role}  setShowSupport={setShowSupport} />
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div
            className={`${isExpanded ? "w-[100%] lg:w-[82%]" : "w-[100%] lg:w-[95%]"} transition-all duration-300 pt-[100px] lg:pt-[110px] px-2 lg:px-6`}
          >
            <TopBar isExpanded={isExpanded} hoverExpand={hoverExpand} handleClick={handleClick} user={user} setExpandHeader={setExpandHeader} />
            <Outlet />
            
            {showAnnouncement && (
              <div className="fixed inset-0 z-[999999999] bg-black/50 backdrop-blur-sm flex justify-center items-center p-4">
                <div className="w-full max-w-lg bg-white dark:bg-slate-900 rounded-xl shadow-2xl animate-[fadeIn_.3s_ease-out] overflow-hidden border border-gray-100 dark:border-slate-700">
                  <div className="p-6">
                    {/* Header with Icon and Title */}
                    <div className="flex items-center gap-4 mb-5">
                      <div className="w-12 h-12 bg-indigo-50 dark:bg-indigo-500/15 text-indigo-600 dark:text-indigo-300 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="fa-solid fa-bullhorn text-xl"></i>
                      </div>
                      <div className="flex-1">
                        <h2 className="text-lg font-bold text-gray-900 dark:text-slate-100">System Announcement</h2>
                        <p className="text-xs text-gray-500 dark:text-slate-400">Important update from administration</p>
                      </div>
                      <button
                        className="w-8 h-8 text-gray-400 dark:text-slate-400 hover:text-gray-600 dark:hover:text-white rounded-full flex items-center justify-center hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
                        onClick={() => setShowAnnouncement(false)}
                      >
                        <i className="fa-solid fa-xmark text-lg"></i>
                      </button>
                    </div>

                    {/* Content */}
                    <div className="text-sm text-gray-700 dark:text-slate-300 prose max-w-none border-t border-b border-gray-50 dark:border-slate-700 py-4 my-4" dangerouslySetInnerHTML={{ __html: announcementData?.content }} />
                    
                    {/* Action Button */}
                    <div className="flex justify-end mt-2">
                      <button
                        className="bg-gray-900 hover:bg-gray-800 text-white px-5 py-2 rounded-lg text-sm font-semibold transition-colors shadow-sm"
                        onClick={() => setShowAnnouncement(false)}
                      >
                        Acknowledge
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

      }
    </Fragment>
  );
};

export default Home;
